import { fetch } from '@atlassian/eoc-fetch';
export const getHeartbeatsEndpoint = teamId => fetch(`/v1/teams/${teamId}/heartbeats`, {
  method: 'GET'
});
export const validateHeartbeatNameEndpoint = (teamId, heartbeatName) => fetch(`/v1/teams/${teamId}/heartbeats/validateEmail?heartbeatName=${encodeURIComponent(heartbeatName)}`, {
  method: 'GET',
  responseType: 'headers'
});
export const createHeartbeatEndpoint = (teamId, heartbeat) => fetch(`/v1/teams/${teamId}/heartbeats`, {
  method: 'POST',
  body: heartbeat
});
export const updateHeartbeatEndpoint = (teamId, heartbeat) => fetch(`/v1/teams/${teamId}/heartbeats`, {
  method: 'PUT',
  body: heartbeat
});
export const switchHeartbeatEndpoint = (teamId, enable, name) => fetch(`/v1/teams/${teamId}/heartbeats/enable?enabled=${enable}&name=${encodeURIComponent(name)}`, {
  method: 'PATCH'
});
export const deleteHeartbeatEndpoint = (teamId, name) => fetch(`/v1/teams/${teamId}/heartbeats?name=${encodeURIComponent(name)}`, {
  method: 'DELETE',
  responseType: 'headers'
});
export const getHeartbeatsUserRights = teamId => {
  return fetch(`/v1/${teamId ? `teams/${teamId}/` : ''}heartbeats/rights`);
};
export const updateAutoCreationEndpoint = (teamId, autoCreateEnabled) => fetch(`/v1/${teamId ? `teams/${teamId}/` : ''}heartbeats/updateHeartbeatAutoCreation?autoCreateEnabled=${autoCreateEnabled}`, {
  method: 'POST',
  responseType: 'headers'
});